export default __webpack_public_path__ + "static/media/pk.71660bcf.svg";